export const setInviteIdSession = (inviteId: string) => {
  sessionStorage.setItem('inviteId', inviteId);
};

export const getInviteIdSession = () => sessionStorage.getItem('inviteId');

export const removeInviteIdSession = () => {
  sessionStorage.removeItem('inviteId');
};
